import React, { Component } from 'react';

export class Address extends Component {
    static displayName = Address.name;

    render() {
        return (
            <div>
                <label>{this.props.label}</label>
                <div className="fakeinput">
                    <div>{this.props.address.line1}</div>
                    <div>{this.props.address.line2}</div>
                    <div>{this.props.address.line3}</div>
                    <div>{this.props.address.line4}</div>
                    <div>{this.props.atlInstructions}</div>
                    <div>{this.props.receiverInstructions}</div>
                </div>
            </div>
        );
    }
}
